import type { ReactNode } from 'react';
import { fmtNum } from './format';
import { StatLabel } from './StatLabel';

// The head line of a stat card: the icon+label on the left, an optional detail
// (a category breakdown, or a qualifier like "1 visit") pushed to the right on
// the SAME line. One shared primitive so every card's head reads the same.
export function StatHead({ icon, label, detail }: { icon: string; label: ReactNode; detail?: ReactNode }) {
  return (
    <div className="stat-head">
      <StatLabel icon={icon}>{label}</StatLabel>
      {detail != null && detail !== '' && <span className="stat-detail">{detail}</span>}
    </div>
  );
}

export interface StatTotalProps {
  icon: string;
  label: ReactNode;
  total: number | null | undefined;
  parts: { label: string; value: number | null | undefined }[];
}

// A total headcount with its per-category split on the label line (Freddi,
// 2026-06-20: the breakdown reads beside the label, not stacked under the
// number). The big total then stands alone below as the card's headline figure —
// the same `.val` number every other stat card uses, so spacing can't drift.
export function StatTotal({ icon, label, total, parts }: StatTotalProps) {
  const detail = parts.map((p) => `${fmtNum(p.value)} ${p.label}`).join(' · ');
  return (
    <>
      <StatHead icon={icon} label={label} detail={detail} />
      <div className="val mono">{fmtNum(total)}</div>
    </>
  );
}
